module.exports = __webpack_public_path__ + "img/3-4.4e83ac97.png";